import "../css/app.scss";

import Burger from "./components/burger";
import Map from "./components/map";
import Gallery from "./components/gallery";
import Navigation from "./components/navigation";

$(() => {
  const $burger = $('[data-burger="el"]');
  if ($burger.length) {
    new Burger($burger);
  }

  const $map = $('[data-contact-map="el"]');
  if ($map.length) {
    new Map($map);
  }

  $('[data-gallery="el"]').each((i, el) => {
    new Gallery($(el));
  });

  $('[data-navigation="el"]').each((i, el) => {
    new Navigation($(el));
  });
});
